import { ModalBody, ModalContent, ModalFooter } from "@nextui-org/react";
import CustomModal from "../CustomModal/CustomModal";
import styles from "./SessionTimeoutModal.module.scss";
import Button from "../Button/Button";

interface SessionTimeoutModalProps {
  isOpen: boolean;
  remainingTime: string;
  onContinue: () => void;
}

const SessionTimeoutModal = ({
  isOpen,
  remainingTime,
  onContinue,
}: SessionTimeoutModalProps) => {
  const { modalBody, textStyle, sessionButton } = styles;

  return (
    <CustomModal 
      isOpen={isOpen} 
      backdrop="opaque" 
      hideCloseButton
      isDismissable={false}
      isKeyboardDismissDisabled={true}
    >
      <ModalContent>
        <ModalBody>
          <div className={modalBody}>
            <h1>{remainingTime}</h1>
            <div className={textStyle}>
              <h2>¿Estás ahí?</h2>
              <span>Por tu seguridad cerraremos tu sesión en breve.</span>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <div className={sessionButton}>
            <Button
              variant="primary"
              text="Continuar sesión"
              onPress={onContinue}
            />
          </div>
        </ModalFooter>
      </ModalContent>
    </CustomModal>
  );
};

export default SessionTimeoutModal;
